<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      shoujiIcon: `${this.$cdnLink}/wanXin/yssl/shoujihao.png`,
      xialaIcon: `${this.$cdnLink}/wanXin/yssl/xiala.png`,
      zhanghao1Icon: `${this.$cdnLink}/wanXin/yssl/zhanghao.png`,
      yanzhengmaIcon: `${this.$cdnLink}/wanXin/yssl/yanzhengma.png`,
      xuanzhongIcon: `${this.$cdnLink}/wanXin/yssl/xuanzhong.png`,
      weixuanzhongIcon: `${this.$cdnLink}/wanXin/yssl/weixuanzhong.png`
    }
  }
};
</script>
<style lang="scss" module>
@import '../../../assets/css/yssl.scss';

.wrap {
  @include common-window(true);
  > header {
    position: relative;
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding-top: 0.15rem;
    .accountWrap {
      position: relative;
      .inputWrap {
        position: relative;
        z-index: 10;
      }
    }
    .inputWrap {
      @include common-inputWrap();
      justify-content: flex-start;
      padding-left: 0.25rem;
      .leftIcon {
        margin-right: 0.16rem;
      }
      &.code {
        margin-top: 0.15rem;
        margin-bottom: 0.1rem;
        > input {
          width: 2.6rem;
        }
        .getCode {
          display: flex;
          align-items: center;
          color: #666666;
          border-left: 1px solid #C9BBB0;
          padding-left: 0.2rem;
          height: 0.5rem;
          font-size: $font-nm-1;
        }
      }
    }
    .cellList {
      position: absolute;
      top: 0.3rem;
      width: 4.44rem;
      left: 0;
      right: 0;
      margin: auto;
      height: 0;
      background: #EADCD0;
      color: #666666;
      border-radius: 4.86px;
      perspective: 1000px;
      overflow: auto;
      z-index: 5;
      &.active {
        height: 2rem;
      }
      li {
        display: flex;
        padding: 0.15rem 0;
        margin: 0 0.3rem;
        align-items: center;
        border-bottom: 1px solid #dad9d9;
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
          border-bottom: 0.5px solid #dad9d9;
        }
        @media screen and (-webkit-min-device-pixel-ratio: 3) {
          border-bottom: 0.333333px solid #dad9d9;
        }
        > img {
          width: 0.22rem;
        }
        > span {
          width: 3.5rem;
          padding-left: 0.1rem;
        }
      }
      li:nth-child(1) {
        padding-top: 0.65rem;
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      font-weight: 500;
      > span {
        // background: #000000;
        padding: 0.24rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
    .agree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.18rem;
      color: #7C927D;
      margin-top: 0.16rem;
      margin-bottom: 0.14rem;
      > img {
        width: 0.17rem;
        height: 0.17rem;
        margin-right: 0.1rem;
      }
    }
    &.hasCellCache {
      padding-top: .5rem;
      .agree {
        margin-top: 0.5rem;
        margin-bottom: 0.22rem;
      }
      .redirect {
        > span {
          padding: 0.26rem 0.22rem 0.22rem 0.29rem;
        }
      }
    }
  }
  &.fullScreen {
    @include full-screen-window(true);
    > header {
      position: relative;
      > span {
        font-weight: 600;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding-top: 13px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        justify-content: flex-start;
        padding-left: 12px;
        .leftIcon {
          margin-right: 8px;
        }
        &.code {
          margin-top: 7px;
          margin-bottom: 5px;
          > input {
            width: 130px;
          }
          .getCode {
            display: flex;
            align-items: center;
            color: #FFE56B;
            border-left: 1px solid #FFE56B;
            padding-left: 10px;
            height: 25px;
            font-size: $font-nm;
          }
        }
      }
      .cellList {
        position: absolute;
        top: 15px;
        width: 222px;
        left: 0;
        right: 0;
        margin: auto;
        height: 0;
        background: #27231b;
        border: 4.86px solid;
        border-image: linear-gradient(0deg, #130f0d 0%, #130f0d 8%, #371e14 50%, #130f0d 92%, #130f0d 100%) 7 7;
        box-shadow: 0px 3.47px 13.86px 0.17px rgba(5,0,0,0.75), 0px 0px 12.51px 0px rgba(255,161,82,0.30) inset; 
        border-radius: 0 0 20px 20px;
        transition: height 200ms ease-in;
        perspective: 1000px;
        overflow: auto;
        z-index: 5;
        &.active {
          height: 100px;
        }
        li {
          display: flex;
          padding: 7px 0;
          margin: 0 15px;
          align-items: center;
          border-bottom: 1px solid #dad9d9;
          @media screen and (-webkit-min-device-pixel-ratio: 2) {
            border-bottom: 0.5px solid #dad9d9;
          }
          @media screen and (-webkit-min-device-pixel-ratio: 3) {
            border-bottom: 0.333333px solid #dad9d9;
          }
          > img {
            width: 11px;
          }
          > span {
            width: 175px;
            padding-left: 5px;
          }
          .del {
            // background-color: #000000;
            width: 32px;
            padding: 0 5px 0 15px;
          }
        }
        li:nth-child(1) {
          padding-top: 32px;
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 12px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
      .agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: #999999;
        margin-top: 8px;
        margin-bottom: 7px;
        > img {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          &.xuanzhong {
            width: 12.5px;
            margin-right: 1px;
          }
        }
      }
      &.hasCellCache {
        padding-top: 25px;
        .agree {
          margin-top: 25px;
          margin-bottom: 11px;
        }
        .redirect {
          > span {
            padding: 13px 11px 11px 15px;
          }
        }
      }
    }
  }
}
</style>
